// extracted by mini-css-extract-plugin
export default {"link":"link_link__+Nznz","icon":"link_icon__CPvCK","linkContent":"link_linkContent__HR+FL"};